<script>
let addedMaterial = []
let fileList = []
let pictureFileList = []
let lastestDownloadList = []
let isUploading = false
let isPicUploading = false
export default {
  addedMaterial,
  fileList,
  pictureFileList,
  lastestDownloadList,
  isUploading,
  isPicUploading
}
</script>
